import { render, staticRenderFns } from "./TabsPanel.vue?vue&type=template&id=c5384dc4&scoped=true"
import script from "./TabsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TabsPanel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5384dc4",
  null
  
)

export default component.exports